import { render, staticRenderFns } from "./DocTemplateVariables.vue?vue&type=template&id=7ae0a784&"
import script from "./DocTemplateVariables.vue?vue&type=script&lang=ts&"
export * from "./DocTemplateVariables.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports